var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReberegning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 200,
    viewBox: "0 0 176 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.2275,
    y: 67.2925,
    width: 89.8796,
    height: 113.894,
    rx: 3,
    fill: "#E3E4FF",
    stroke: "#E3E4FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2119 88.8038V84.6221H134.487V88.8038H95.2119Z",
    fill: "#C5C5C5",
    stroke: "#F8F2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2119 100.99V96.8079H141.196V100.99H95.2119Z",
    fill: "#C5C5C5",
    stroke: "#F8F2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2119 127.496V123.314H126.138V127.496H95.2119Z",
    fill: "#C5C5C5",
    stroke: "#F8F2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2119 139.021V134.84H141.196V139.021H95.2119Z",
    fill: "#C5C5C5",
    stroke: "#F8F2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2119 164.505V160.323H141.196V164.505H95.2119Z",
    fill: "#F8F2FF",
    stroke: "#F8F2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2119 114.256V110.074H134.487V114.256H95.2119Z",
    fill: "#C5C5C5",
    stroke: "#F8F2FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.726 88.7223V84.5405H162.785V88.7223H154.726Z",
    fill: "#F8F2FF",
    stroke: "#F8F2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.726 101.448V97.2664H162.785V101.448H154.726Z",
    fill: "#F8F2FF",
    stroke: "#F8F2FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.726 114.174V109.992H162.785V114.174H154.726Z",
    fill: "#F8F2FF",
    stroke: "#F8F2FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.726 126.932V122.75H162.785V126.932H154.726Z",
    fill: "#F8F2FF",
    stroke: "#F8F2FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.726 139.653V135.471H162.785V139.653H154.726Z",
    fill: "#F8F2FF",
    stroke: "#F8F2FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.726 165.144V160.962H162.785V165.144H154.726Z",
    fill: "#F8F2FF",
    stroke: "#F8F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.983635
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6912 34.7H141.841C144.033 34.7 145.81 36.4769 145.81 38.6685V144.777C145.81 146.969 144.033 148.746 141.841 148.746H57.6912C55.4996 148.746 53.7227 146.969 53.7227 144.777V38.6685C53.7227 36.4769 55.4996 34.7 57.6912 34.7Z",
    fill: "#2D0067",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7109 45.3743H132.486C133.582 45.3743 134.47 46.2622 134.47 47.3586V66.3085C134.47 67.4043 133.582 68.2928 132.486 68.2928H66.7109C65.615 68.2928 64.7266 67.4043 64.7266 66.3085V47.3586C64.7266 46.2622 65.615 45.3743 66.7109 45.3743Z",
    fill: "#E3E4FF"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M131.476 8.65186L136.703 25.0079",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M146.827 27.5865L156.184 11.3811",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M154.737 34.6914L163.073 32.6128L170.871 30.6686",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M125.466 50.7431C125.466 52.2079 124.278 53.3953 122.813 53.3953C121.349 53.3953 120.161 52.2079 120.161 50.7431C120.161 49.2783 121.349 48.0908 122.813 48.0908C124.278 48.0908 125.466 49.2783 125.466 50.7431Z",
    fill: "#2D0067"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.121 58.6891L123.369 63.1613L124.709 62.6972L125.777 65.7818L123.762 66.4797C122.603 66.8813 121.325 66.3624 120.774 65.266L119.393 62.5209L115 63.6803L114.167 60.5241L121.121 58.6891Z",
    fill: "#2D0067"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 115.497,
    y: 53.9485,
    width: 14.6893,
    height: 2.04018,
    transform: "rotate(8.52699 115.497 53.9485)",
    fill: "#2D0067"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5889,
    y: 79.7283,
    width: 13.0018,
    height: 13.0018,
    rx: 4,
    fill: "#E3E4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120.497,
    y: 100.965,
    width: 13.0018,
    height: 13.0018,
    rx: 4,
    fill: "#E3E4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5889,
    y: 121.335,
    width: 13.0018,
    height: 13.0018,
    rx: 4,
    fill: "#E3E4FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89.8184,
    y: 98.3645,
    width: 12.5684,
    height: 12.5684,
    rx: 4,
    transform: "rotate(45 89.8184 98.3645)",
    fill: "#E3E4FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 119.631,
    y: 78.8623,
    width: 14.7354,
    height: 14.7354,
    rx: 7.36771,
    fill: "#E3E4FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 63.7227,
    y: 100.099,
    width: 14.7354,
    height: 14.7354,
    rx: 7.36771,
    fill: "#E3E4FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 100.562,
    y: 121.335,
    width: 33.8048,
    height: 13.8686,
    rx: 4,
    fill: "#E3E4FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.631 80.9961C107.401 79.6628 109.325 79.6628 110.095 80.9961L114.888 89.2981C115.658 90.6314 114.696 92.2981 113.156 92.2981H103.57C102.03 92.2981 101.068 90.6314 101.838 89.2981L106.631 80.9961Z",
    fill: "#E3E4FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1714 121.606C94.6585 121.208 96.0193 122.568 95.6209 124.056L93.1397 133.315C92.7412 134.802 90.8823 135.301 89.7937 134.212L83.0151 127.433C81.9264 126.345 82.4245 124.486 83.9117 124.087L93.1714 121.606Z",
    fill: "#E3E4FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.775 79.6221C89.0744 78.7008 90.3778 78.7008 90.6771 79.6221L91.6422 82.5924C91.7761 83.0044 92.1601 83.2834 92.5933 83.2834H95.7164C96.6851 83.2834 97.0879 84.523 96.3042 85.0924L93.7775 86.9281C93.4271 87.1828 93.2804 87.6341 93.4143 88.0461L94.3794 91.0164C94.6787 91.9377 93.6242 92.7039 92.8405 92.1344L90.3139 90.2987C89.9634 90.0441 89.4888 90.0441 89.1383 90.2987L86.6116 92.1344C85.8279 92.7039 84.7734 91.9377 85.0728 91.0164L86.0379 88.0461C86.1718 87.6341 86.0251 87.1828 85.6746 86.9281L83.148 85.0924C82.3643 84.523 82.767 83.2834 83.7357 83.2834H86.8589C87.2921 83.2834 87.6761 83.0044 87.8099 82.5924L88.775 79.6221Z",
    fill: "#E3E4FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.412 101.292C107.711 100.37 109.015 100.37 109.314 101.292L110.279 104.262C110.413 104.674 110.797 104.953 111.23 104.953H114.353C115.322 104.953 115.725 106.192 114.941 106.762L112.414 108.598C112.064 108.852 111.917 109.304 112.051 109.716L113.016 112.686C113.315 113.607 112.261 114.373 111.477 113.804L108.951 111.968C108.6 111.714 108.126 111.714 107.775 111.968L105.248 113.804C104.465 114.373 103.41 113.607 103.71 112.686L104.675 109.716C104.808 109.304 104.662 108.852 104.311 108.598L101.785 106.762C101.001 106.192 101.404 104.953 102.372 104.953H105.496C105.929 104.953 106.313 104.674 106.447 104.262L107.412 101.292Z",
    fill: "#E3E4FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57745 181.833C6.29578 178.533 8.18846 174.198 8.79941 170.887C9.30158 168.165 10.4121 165.61 11.2456 162.979C12.6541 158.534 14.0215 154.079 16.0589 149.847C17.6816 146.477 19.9701 143.223 21.2763 139.81C22.9621 135.407 26.2469 126.573 31.3786 125.467C33.9057 124.922 35.2221 129.102 36.0711 128.199C38.1877 125.949 39.7674 123.894 42.2845 124.275C44.2366 124.571 44.7497 128.665 44.9018 128.545C46.3001 127.442 47.8073 124.944 50.7183 127.061C52.0458 128.025 52.074 130.977 52.2364 132.451C52.5426 135.232 52.3084 135.402 52.538 135.236C53.8917 134.253 56.6906 132.189 57.8821 131.369C61.3589 128.975 64.0062 127.445 68.1265 126.349C69.9379 125.868 72.8801 125.15 73.511 127.521C74.1826 130.047 70.8486 132.633 69.3007 134.228C66.9246 136.676 64.3578 138.612 61.6618 140.698C60.3397 141.721 59.1118 142.927 57.8333 143.916C55.312 145.867 54.7625 146.306 53.541 147.733C52.0553 149.47 50.7611 150.807 51.0171 150.697C52.5417 150.039 53.4752 150.107 54.1703 150.213C55.0778 150.35 57.1831 151.943 57.5472 152.779C58.4612 154.875 58.8479 156.294 58.1366 159.332C57.9934 159.945 57.1779 161.972 56.7909 162.504C56.1476 163.39 55.9559 164.041 55.3151 164.922C53.7938 167.016 52.5681 168.485 50.472 170.106C49.839 170.596 48.6067 171.514 47.9364 172.032C44.9394 174.351 42.5795 177.277 39.6403 179.551C38.3736 180.531 36.7539 183.096 35.7355 184.356C32.9466 187.806 31.6276 189.87 28.3365 193.316C27.1516 194.557 26.7066 196.509 25.8033 197.807C24.7805 199.277 16.6536 195.084 15.1349 193.979C12.0278 191.721 9.82586 189.387 8.34174 187.293C6.88835 185.243 6.7757 184.156 6.57745 181.833Z",
    fill: "#FFE1D1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.18 128.854C61.9964 129.21 61.939 129.974 62.0783 130.691C62.2683 131.668 63.5193 132.785 64.31 133.098C66.6094 134.008 70.188 131.282 71.4782 130.25C73.0428 128.999 72.9478 126.454 72.5755 126.014C71.4432 124.678 67.4186 126.228 65.5596 126.982C64.9869 127.214 64.1957 127.583 63.6205 127.801C63.3861 127.891 62.2393 128.74 62.18 128.854Z",
    fill: "#FAF1F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4538 147.173C36.0563 146.38 37.3189 146.108 38.0817 145.587C39.9759 144.292 42.3082 143.091 44.0009 141.54C45.9048 139.797 48.3144 138.172 50.4879 136.686C54.9006 133.669 58.8712 130.24 63.7131 127.856C66.3384 126.562 73.9677 122.921 74.0306 128.297C74.0497 129.963 72.8198 131.439 72.0897 132.426C70.5844 134.459 63.3098 139.359 61.9795 140.455C60.0958 142.007 56.9511 144.458 55.6976 145.601C54.3998 146.785 51.9958 149.496 50.3718 151.153C48.0796 153.492 45.6633 157.962 44.1278 162.116",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3512 150.244C55.1693 149.155 58.4359 152.461 58.6526 156.109C58.7732 158.149 57.8666 160.194 57.0523 161.966C54.326 167.899 49.115 171.842 44.3682 175.89C42.6493 177.355 40.5685 179.219 39.2666 180.546C36.1902 183.682 35.7479 184.745 33.6459 187.013C32.8631 187.858 30.7827 190.333 29.3323 192.252C28.683 193.111 27.0757 195.265 25.4913 197.969",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0853 135.564C52.5558 133.061 52.7556 126.41 48.748 126.457C47.2989 126.473 45.7293 127.799 44.588 128.67C38.5955 133.246 33.7784 138.19 29.2904 144.1",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1561 127.862C44.532 126.949 44.0478 124.891 42.9674 124.455C40.5745 123.491 37.8377 126.204 36.3005 127.612C33.1997 130.452 30.5054 133.672 27.9579 137.027C26.898 138.423 26.2759 139.48 25.2031 141.502",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5883 128.28C34.8203 125.587 31.7097 124.377 29.4649 125.912C26.5495 127.904 24.6212 131.361 23.408 134.674C20.5144 142.579 15.462 149.786 12.7389 157.797C11.621 161.086 10.5784 164.403 9.38939 167.651C8.71808 169.485 8.56061 170.196 7.57492 175.578C7.41127 176.472 7.09527 179.141 6.56014 182.263",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5657 125.505C73.8088 125.134 72.8372 128.26 72.4049 128.916C70.7044 131.491 66.0111 134.162 63.9355 133.161C62.6281 132.53 61.4807 131.214 61.9701 128.776",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReberegning);
export default __webpack_public_path__ + "static/media/Reberegning.ea79430a1e1c9d8eb1e780f9418a6daa.svg";
export { ForwardRef as ReactComponent };